export default __webpack_public_path__ + "static/media/Slide_2.9cfd637d.jpeg";